import React from 'react';
import classNames from 'classnames';
import SearchBar from 'src/modules/search/shared/components/searchBar';

type Props = {
  title?: string;
  isMobile?: boolean;
  placeholder: string;
  isCommunitySearch?: boolean;
}

export default function SearchBox({ title, placeholder, isCommunitySearch, isMobile }: Props): JSX.Element {
  const classes = classNames({
    'search-box': true,
    'search-box__mobile': !!isMobile,
  });

  return (
    <div className={classes}>
      {title && (
        <h2 className="search-box__header">
          {title}
        </h2>
      )}
      <div className="search-box__search-bar">
        <SearchBar
          isCommunitySearch={isCommunitySearch}
          placeholderText={placeholder}
        />
      </div>
    </div>
  );
}
